export default __webpack_public_path__ + "static/Logo_Koenigs_Partner-2Sterne-2024-0e8e0e63bf939fac4afd03fe2d82b53b.png";